<template>
  <section class="board-tab3" :style="dBHeight">
    <h2 class="hide">파일</h2>
    <!-- <BoardHeader/> -->

    <div class="board-tit1">{{ $i18nUtil.trans("title.BoardFiles.001","파일") }}</div>

    <div class="tb-list_ty1">
      <div class="tb-header clear media">
        <div class="tb_num fl">
          <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: totalBoardFileCount})"></div>
            <!-- 검색 조회시 노출 S -->
            <div class="check_result" v-if="show">
              <div class="txt" v-html="$i18nUtil.trans('search.000.result','{search} 검색 결과 총 {cnt}건', {search: searchResult, cnt: totalBoardFileCount})"></div>
              <button type="button" @click="resetFileList">초기화</button>
            </div>
            <!-- //검색 조회시 노출 E -->
        </div>

        <div class="tb_sort fr">
          <div class="search_ty2">
            <button type="button" class="search-show" :class="isOpenSearch ? 'active' : ''" @click="isOpenSearch = true">검색</button>
            <form action="" onsubmit="return false;" class="search-show">
              <div class="input-box">
                <input type="text"
                  class="search-show"
                  :class="searchKeyword == '' ? 'ico_search' : ''"
                  v-model="searchKeyword"
                  :placeholder="$i18nUtil.trans('message.placeholder.fileName','파일명 검색')"
                  @keyup.enter="searchFileList(true)"
                  @focus="$event.target.placeholder = ''"
                  @focusout="$event.target.placeholder = $i18nUtil.trans('message.placeholder.fileName','파일명 검색')"
                  maxlength="21"
                >
                <!-- <button type="button" class="input-txt-del" @click="searchFileList($event)">입력 삭제</button> -->
                <button type="reset" 
                  class="input-txt-del search-show" 
                  v-if="searchKeyword != ''"
                  @click="searchKeyword = ''" 
                >
                  입력 삭제
                </button>
                <button type="reset" 
                  class="btn_search search-show" 
                  @click="searchFileList(true)"
                >
                  검색
                </button>
              </div>
            </form>
          </div>
          <BoardFileFilterBox
            ref="boardFileFilterBox"
            :extList="extList"
            :checkCount="checkCount"
            :checkFileLocations="checkFileLocations"
            :checkFileExts="checkFileExts"
            @applyFilter="applyFilter"
          />
          <div class="dividing_line_ty1"></div>
          <button type="button" class="btn-primary-small black" @click="downloadCheckedFile">{{ $i18nUtil.trans("button.file.download","다운로드") }}</button>
        </div>
      </div>
      <FileTable ref="fileTable"
        :filteredFileList="filteredFileList"
        :show="show"
        :totalBoardFileCount="totalBoardFileCount"
        @getBoardFileList="getBoardFileList"
        @downloadSelectedFile="downloadSelectedFile"
        @confirmDeleteFile="confirmDeleteFile"
      />
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import BoardFileFilterBox from "@/components/cowork/general/filter/BoardFileFilterBox";
import EventBus from "@/js/eventbus/eventBus";
import Datepicker from 'vuejs-datepicker';
// import BoardHeader from "./BoardHeader";
import FileTable from "./FileTable";

export default {
  components: {
    // Datepicker,
    // BoardHeader,
    BoardFileFilterBox,
    FileTable
  },
  props: {
    paperInfo: Object
  },
  data() {
    return {
      totalBoardFileCount: 0,
      fileList: [],
      filteredFileList: [],
      /* 필터 관련 */
      extList: [
        { name : 'PPT', value : 'ppt' },
        { name : 'EXCEL', value : 'excel' },
        { name : 'WORD', value : 'word' },
        { name : 'HWP', value : 'hwp' },
        { name : 'PDF', value : 'pdf' },
        { name : 'IMG', value : 'img' },
        { name : 'ZIP', value : 'zip' },
        { name : 'ETC', value : 'etc' }
      ], // 파일 유형 목록
      /* userList: [], */ // 생성/수정자 목록
      checkCount: 0, // 체크한 필터 수
      checkFileLocations: [], // 체크한 파일 경로 목록
      checkFileExts: [], // 체크한 파일 유형 목록
      /* checkFileEditors: [], */ // 체크한 생성/수정자 목록
      /* 검색 관련 */
      show: false,
      searchKeyword: '',
      searchResult: '',
      isOpenSearch: false,
      /* 토스트 알림 */
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      dBHeight: {
        'min-height': (window.innerHeight + 310) + 'px',
      },
    };
  },
  created() {
    EventBus.$off("deleteBoardOutputFile");
    EventBus.$on("deleteBoardOutputFile", payload => {
      this.getBoardFileList(false);
    });
    EventBus.$off("uploadBoardOutputFile");
    EventBus.$on("uploadBoardOutputFile", payload => {
      this.getBoardFileList(false);
    });
  },
  mounted() {
    const self = this;
    $("html").click(function (e) {
      if(!$(e.target).hasClass("input-box") && !$(e.target).hasClass('search-show')) {
        self.isOpenSearch = false;
      }
    });
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("modals", ["showModal"]),
    ...mapActions("modals", ["showToast"]),
    /* 보드 파일 목록 조회 */
    getBoardFileList(isRefresh) {
      let obj = this;
      let groupId = obj.paperInfo.groupId;
      let paperInfoList = [];
      let paperInfo = {};
      
      paperInfo.kbn = "PROJECT";
      paperInfo.paperId = obj.paperInfo.paperId;
      paperInfo.categoryMid = obj.paperInfo.categoryInfo.categoryMid;
      paperInfo.categoryName = obj.paperInfo.categoryInfo.categoryName;
      
      paperInfoList.push(paperInfo);

      if(isRefresh) { // 초기화
        obj.show = false;
        obj.isOpenSearch = false;
        obj.searchKeyword = '';
        obj.searchResult = '';
        obj.$refs.fileTable.selected = [];
        obj.$refs.fileTable.page = 1;
        obj.$refs.fileTable.sortBy = 'lastModDate';
        obj.$refs.fileTable.sortDesc = true;

        /* 필터 초기화 */
        obj.checkCount = 0;
        obj.checkFileLocations = [];
        obj.checkFileExts = [];
        obj.$refs.boardFileFilterBox.prevModelFileLocationCodeList = [];
        obj.$refs.boardFileFilterBox.prevModelExtCodeList = [];
        obj.$refs.boardFileFilterBox.modelFileLocationCodeList = [];
        obj.$refs.boardFileFilterBox.modelExtCodeList = [];
      }

      let reqData = {
        url: '/api/cofile/cofile/getBoardFileList',
        method: 'post',
        req: {
          groupId : groupId,
          paperInfoList : paperInfoList,
          searchKeyword : obj.searchKeyword,
          page : obj.$refs.fileTable.page - 1, // 현재 페이지
          itemsPerPage : obj.$refs.fileTable.itemsPerPage, // 페이지당 파일 수
          sortBy : obj.$refs.fileTable.sortBy, // 정렬기준 (fileName, lastModDate, lastModUserName)
          sortDesc : obj.$refs.fileTable.sortDesc, // 정렬순서 (true: 내림차순, false: 오름차순)
          fileLocationFilter: obj.checkFileLocations, // 체크한 파일 경로 목록
          fileExtFilter: obj.checkFileExts, // 체크한 파일 유형 목록
        }
      };

      obj.COWORK_REST_ACTION(reqData)
        .then(function(res) {
          let errorCode = res.errorCode;
          if(errorCode == null) {
            obj.totalBoardFileCount = res.result.totalBoardFileCount;
            obj.$refs.fileTable.pageCount = res.result.totalPageCount;
            obj.fileList = res.result.fileList;
            let list = res.result.fileList;
            if(obj.$i18nUtil.getLanguage() !== 'ko') {
              list.forEach(item => {
                if(item.locationKbn === 'BLOCK') {
                  item.locationKbnDesc = obj.$i18nUtil.trans("entity.file.locationKbn.block", "보드 첨부파일")
                }else if(item.locationKbn === 'DECISION') {
                  item.locationKbnDesc = obj.$i18nUtil.trans("entity.file.locationKbn.decision", "의사결정")
                }else {
                  item.locationKbnDesc = obj.$i18nUtil.trans("entity.file.locationKbn.output", "최종결과물")
                }
              })
            }
            obj.filteredFileList = list;
            /* obj.userList = res.result.userList; */
            obj.searchResult = res.result.searchKeyword;
            obj.searchKeyword = res.result.searchKeyword;
            obj.show = obj.searchResult != '' ? true : false;
          } else {
            console.log('Error Occured. errorcode : ' + errorCode);
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    /* 필터 적용 */
    applyFilter(_data) {
      let obj = this;
      obj.checkCount = _data.checkFilterCount;
      obj.checkFileLocations = _data.checkFileLocationsFilter;
      obj.checkFileExts = _data.checkFileExtsFilter;
      obj.$refs.fileTable.page = 1;
      obj.$refs.fileTable.selected = []; // 체크된 파일 체크 해제

      // 파일 목록 API 호출
      obj.getBoardFileList();
    },
    /* 체크된 파일 다운로드 */
    downloadCheckedFile() {
      let obj = this;
      let selected = obj.$refs.fileTable.selected;
      let fileName = '';
      let param = {};

      if(selected.length === 0) {
        // AlertModal - 파일을 선택해 주세요.
        obj.showAlertDialog(obj.$i18nUtil.trans("AB061"));
        return;
      } else if(selected.length > 1) { // 파일 멀티 다운로드
        // 프로그레스바 시작
        obj.showLoadingbar();

        let fileIds = [];
        for(let i=0; i<selected.length; i++) {
          fileIds.push(selected[i].id.toString());
        }

        param.groupId = obj.paperInfo.groupId;
        param.fileIds = fileIds;
        param.type = 'MULTI';
        param.groupKbn = obj.paperInfo.groupInfo.groupKbn;
        
        // 파일 멀티 다운로드 시 압축파일명 - 보드명.zip
        fileName = obj.paperInfo.paperTitle + '.zip';
      } else { // 파일 개별 다운로드
        // 프로그레스바 시작
        obj.showLoadingbar();

        let fileId = selected[0].id.toString();
        
        param.groupId = obj.paperInfo.groupId;
        param.fileId = fileId;
        param.type = 'SINGLE';
        param.groupKbn = obj.paperInfo.groupInfo.groupKbn;

        fileName = selected[0].fileName;
      }
      
      obj.$axios({
        url: "/api/cofile/cofile/download",
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        },
        method: "post",
        data: param
      })
      .then(res => {
        //프로그레스바 종료 
        obj.hideLoadingbar();
        try {
          let blob = new Blob([res.data], {
            type: res.headers["content-type"]
          });

          // 에러코드 체크
          if(res.data.type.startsWith("application/json")) {
            let errorCode = obj.blobToString(blob);
            if(errorCode == "NOT_AUTHORIZED") {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB044");
              obj.showToast(obj.toastInfo);
              return;
            } else if(errorCode == "COFILE_FILE_DOWNLOAD_DENIED_FROM_EXTERNAL") {
              obj.showAlertDialog(obj.$i18nUtil.trans("AB101"));
              return;
            } else {
              obj.showAlertDialog(obj.$i18nUtil.trans("AB077"));
              return;
            } 
          }

          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            let link = document.createElement("a");
            link.target = "_self";
            link.setAttribute("download", fileName);
            link.href = window.URL.createObjectURL(blob);
            link.click();
            link.remove();
          }
        } catch (e) {
          obj.showAlertDialog(obj.$i18nUtil.trans("AB077"));
          console.error(e);
        }
      })
      .catch(res => {
        //프로그레스바 종료 
        obj.hideLoadingbar();
        obj.showAlertDialog(obj.$i18nUtil.trans("AB077"));
        console.log(res);
      });
    },
    /* 선택한 파일 다운로드 */
    downloadSelectedFile(file) {
      let obj = this;
      let fileId = file.id.toString();
      let fileName = file.fileName;
      let param = {};

      param.groupId = obj.paperInfo.groupId;
      param.fileId = fileId;
      param.type = 'SINGLE';
      param.groupKbn = obj.paperInfo.groupInfo.groupKbn;
      
      // 프로그레스바 시작
      obj.showLoadingbar();
      obj.moreMenuClose();
      obj.$axios({
        url: "/api/cofile/cofile/download",
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        },
        method: "post",
        data: param
      })
      .then(res => {
        //프로그레스바 종료 
        obj.hideLoadingbar();
        try {
          let blob = new Blob([res.data], {
            type: res.headers["content-type"]
          });

          // 에러코드 체크
          if(res.data.type.startsWith("application/json")) {
            let errorCode = obj.blobToString(blob);
            if(errorCode == "NOT_AUTHORIZED") {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB044");
              obj.showToast(obj.toastInfo);
              return;
            } else if(errorCode == "COFILE_FILE_DOWNLOAD_DENIED_FROM_EXTERNAL") {
              obj.showAlertDialog(obj.$i18nUtil.trans("AB101"));
              return;
            } else {
              obj.showAlertDialog(obj.$i18nUtil.trans("AB077"));
              return;
            } 
          }

          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            let link = document.createElement("a");
            link.target = "_self";
            link.setAttribute("download", fileName);
            link.href = window.URL.createObjectURL(blob);
            link.click();
            link.remove();
          }
        } catch (e) {
          obj.showAlertDialog(obj.$i18nUtil.trans("AB077"));
          console.error(e);
        }
      })
      .catch(res => {
        //프로그레스바 종료 
        obj.hideLoadingbar();
        obj.showAlertDialog(obj.$i18nUtil.trans("AB077"));
        console.log(res);
      });
    },
    /* 파일 삭제 확인 모달 */
    confirmDeleteFile(item) {
      let obj = this;

      obj.moreMenuClose();
      // ConfirmModal - 파일을 삭제하시겠습니까?
      obj.showConfirmDialog(
        { width: "400px" },
        obj.$i18nUtil.trans("title.dialog.notice","알림"),
        obj.$i18nUtil.trans("AB013"),
        obj.$i18nUtil.trans("button.dialog.delete","삭제"),
        obj.deleteFile,
        { groupId: item.groupId, fileId: item.id.toString(), locationKbn: item.locationKbn },
        obj.$i18nUtil.trans("button.dialog.cancel","취소"),
        null,
        "deleteFile"
      );
    },
    /* 파일 삭제 */
    deleteFile(_data) {
      let obj = this;
      let locationKbn = _data.modalParam.locationKbn;
      let reqData = {
        url: "/api/cofile/paper/deleteAttach",
        method: "post",
        req: {
          groupId: _data.modalParam.groupId,
          fileId: _data.modalParam.fileId,
        },
      };

      // 프로그레스바 시작
      obj.showLoadingbar();
      obj.COWORK_REST_ACTION(reqData)
        .then(function(res) {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          let errorCode = res.errorCode;
          if(errorCode == null) {
            obj.searchKeyword = obj.searchResult; // 검색 상태 유지
            obj.$refs.fileTable.page = 1;
            obj.getBoardFileList(false);
            if (locationKbn == "OUTPUT") {
              EventBus.$emit("deleteOutputFile", _data.modalParam.fileId);
            }
            obj.toastInfo.message = obj.$i18nUtil.trans("TB011"); // 파일이 삭제되었습니다.
            obj.showToast(obj.toastInfo);
          } else {
            console.log('Error Occured. errorcode : ' + errorCode);
            if(res.errorMessage != null && res.errorMessage == "2700"){
              obj.$refs.fileTable.fileBtnDisabledYn = true;
              obj.$refs.fileTable.fileLockYn = true;
            }
          }
        })
        .catch(function(err) {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          console.log(err);
        });
    },
    /* 검색창 오픈 */
    openSearch(e) {
      e.target.classList.toggle('active');

      // 검색창 오픈 시 input 포커싱 => input 포커싱되면 IE에서 placeholder가 안보여서 주석 처리
      //if(e.target.classList.contains('active')) {
      //  e.target.nextElementSibling.childNodes[0].focus();
      //}
    },
    /* 파일명 검색 */
    searchFileList(isOpenSearch) {
      let obj = this;

      if(isOpenSearch) {
        if(obj.searchKeyword == '') {
          obj.toastInfo.message = obj.$i18nUtil.trans("TB091");
          obj.showToast(obj.toastInfo);
          return;
        }
      }

      obj.$refs.fileTable.selected = [];
      obj.$refs.fileTable.page = 1;
      obj.getBoardFileList(false);
    },
    /* 검색 조건 초기화 */
    resetFileList() {
      let obj = this;

      obj.$refs.fileTable.selected = [];
      obj.$refs.fileTable.page = 1;
      obj.searchKeyword = '';
      obj.getBoardFileList(false);
    },
    /* 더보기 메뉴 전체 닫기 */
    moreMenuClose() {
      let moreElement = this.$el.getElementsByClassName('more');
      for(let idx=0; idx<moreElement.length; idx++) {
        if(moreElement[idx].parentElement.classList.contains("active")) {
          moreElement[idx].parentElement.classList.remove("active");
        }
      }
    },
    /* 파일 뷰어 */
    openFileViewer(file) {
      let hanwha = $(location).attr("origin");
      let groupId = file.groupId;
      if (groupId != null || groupId != "") {
        window.open(
          hanwha + "/general/viewer/" + groupId + "/" + file.id
        );
      }
    },
    /* blob To string */
    blobToString(blob) {
      let u, x;
      u = URL.createObjectURL(blob);
      x = new XMLHttpRequest();
      x.open('GET', u, false);
      x.send();
      URL.revokeObjectURL(u);
      return x.responseText;
    },
  },  
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/board/files/BoardFiles.vue